// @flow

/**
 * Shared dialog form styles to ensure consistency across all dialogs
 * These styles provide standardized spacing, layout, and appearance for form elements
 */

const sharedDialogStyles = {
  // Dialog container styles
  dialogFormCtr: (theme) => ({
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '80vh'
  }),
  
  // Flex container for dialog content  
  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }),
  
  // Standard input spacing - use for all form inputs
  // This ensures consistent 16px spacing between form elements
  secondInput: (theme) => ({
    marginTop: theme.spacing(2) // Standard 16px spacing
  }),
  
  // Error text styling
  error: (theme) => ({
    color: theme.palette.error.main
  }),
  
  // Grow container for flexible layouts
  grow: (theme) => ({
    flexGrow: 1
  }),
  
  // Standard card styling for dropdowns and selectors
  card: (theme) => ({
    borderRadius: 0,
    width: 200
  }),
  
  // Container for autocomplete and dropdown components
  container: (theme) => ({
    position: 'relative'
  }),
  
  // Paper styling for dropdown menus
  paper: (theme) => ({
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  }),
  
  // Input field styling for autocomplete
  inputRoot: (theme) => ({
    '& label + div': {
      marginTop: theme.spacing(3)
    }
  }),
  
  inputInput: (theme) => ({
    width: 'auto',
    flexGrow: 1
  }),
  
  // Clickable item styling
  itemTextCtr: (theme) => ({
    cursor: 'pointer'
  }),
  
  // Warning text styling
  warning: (theme) => ({
    color: theme.palette.error.main
  }),
  
  // Standard select dropdown styling for dialogs - USE THIS for all dialog Select components
  // Provides underline-only style that matches Input components with exact 25px height
  // Apply as: <Select variant="standard" sx={classes.selectStandard}>
  selectStandard: (theme) => ({
    minHeight: '1.1876em',  // Match MUI Input standard height for consistent alignment
    maxHeight: '25px',      // Force max height to match Phone input exactly
    paddingTop: '3px',      // Reduce from default 4px
    paddingBottom: '3px',   // Reduce from default 5px
    '&.MuiInput-input': {
      paddingTop: '3px',
      paddingBottom: '3px'
    },
    '&:before': {
      borderBottom: `1px solid ${theme.palette.divider}`
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: `1px solid ${theme.palette.text.primary}`
    },
    '&:after': {
      borderBottom: `2px solid ${theme.palette.primary.main}`
    }
  }),
  
  // Standard form control wrapper for dialog Select components - USE THIS for consistency
  // Apply as: <FormControl variant="standard" sx={classes.formControlStandard}>
  formControlStandard: (theme) => ({
    width: '100%',
    marginTop: theme.spacing(1)
  })
};

export default sharedDialogStyles;